import { render, staticRenderFns } from "./ManagementContent.vue?vue&type=template&id=610766c0&scoped=true&"
import script from "./ManagementContent.vue?vue&type=script&lang=ts&"
export * from "./ManagementContent.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementContent.vue?vue&type=style&index=0&id=610766c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610766c0",
  null
  
)

export default component.exports